/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import APP_CONST from "../../../shared/constants";
import DocumentActionModal from "./DocumentActionModal";
import * as fileUploadActions from "../../../../store/actions/fileUploadActions";
import * as documentActions from "../../../../store/actions/documentActions";
import * as zoneActions from "../../../../store/actions/zoneActions";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import WebView from "../../shared/WebView/WebView";
import {
  ViedocButtonElement,
  ViedocDialogElement,
  ViedocMenuItemElement,
  ViedocSelectElement,
} from "../../../../secure/elements/ViedocReactElements";
import DeleteDocumentPopUp from "../../shared/DeleteDocumentPopUp/DeleteDocumentPopUp";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import _ from "underscore";
import DocumentEditForm from "./DocumentEditForm";
import CloseConfirmationPopUp from "../../shared/CloseConfirmationPopUp/CloseConfirmationPopUp";
import Loader from "../../shared/Loader/Loader";
import moment from "moment";
import FileSharingDialog from "./FileSharingDoc/FileSharingDialog";

const DocumentViewModal = ({
  docDetails,
  onDownloadIconClick,
  setViewDocumentObj,
  setDocFilterUsed,
  selectedArtifactDetails,
  isDocViewVisible,
  setIsDocViewVisible,
  from,
  documentPermission,
  downloadingDocId,
  setTmpFileGuid,
  setTmpSingleFileDetail,
  setIsDocNewVersionCreated
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const documentActionUnlock = () => {
    setDocActionObj(true);
  };
  const ref = useRef(null);
  const ResizeHandle = useRef(null);
  const unSavedFormFields = useRef(null);
  const [docDetailsList, setdocDetailsList] = useState({ ...docDetails });
  const [isDropZoneDoc, setIsDropZoneDoc] = useState(
    !!docDetailsList.tmfdropzoneid
  );
  const [docPermission, setDocPermission] = useState(documentPermission);
  const [artifactUserAccess, setArtifactUserAccess] = useState([]);
  const [addedComments, setAddedComments] = useState(0);
  const [docActionObj, setDocActionObj] = useState(false);
  const [isDocVisible, setIsDocVisible] = useState(false);
  const [showDocDeletePopup, setShowDocDeletePopup] = useState(false);
  const [docDeleteData, setDocDeleteData] = useState({});
  const [sectionOrigid, setSectionOrigid] = useState("");
  const [fullDocument, setfullDocument] = useState(false);
  const [isNotDragging, setIsNotGragging] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditModeClicked, setIsEditModeClicked] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [actionText, setActionText] = useState(null);
  const [actionId, setActionId] = useState(null);
  const [isAwaitingFlagged, setIsAwaitingFlagged] = useState(false);
  const [showCloseConfirmation, setShowCloseConfirmation] = useState(false);
  const [showRequiredWarnings, setShowRequiredWarnings] = useState(false);
  const [isEditFormTouched, setIsEditFormTouched] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [singleFileUploaded, setSingleFileUploaded] = useState(false);
  const [newArtifactId, setNewArtifactId] = useState("");
  const [isNewVersionCreated, setIsNewVersionCreated] = useState(false);
  const [newVersionType, setNewVersionType] = useState("");
  const [latestDocVersion, setLatestDocVersion] = useState(true);
  const [tmpGuid, setTmpGuid] = useState(null);
  const [singleFileDetail, setSingleFileDetail] = useState(null);
  const [isRelocatingDoc, setIsRelocatingDoc] = useState(false);
  const [resetFormToInitial, setResetFormToInitial] = useState(false);
  const [notesId, setNotesId] = useState(null);
  const [isErrorFile, setIsErrorFile] = useState(false);
  const [showFormField, setShowFormField] = useState({
    isOpen: false,
    recordStatus: "",
  });
  const [isPortfolioTabOpen, setIsPortfolioTabOpen] = useState(false);

  const {
    countrySiteList,
    userList,
    apiInitConfigObj,
    documentDataList,
    isReadOnlyUser,
    relocatedDoc,
    isDocShareViedocUser,
    isDocShareViedocMeUser,
    isReadOnlySharingPanel,
    newlyModifiedDocumentData,
    latestDocumentDetails,
    docNewVersionXFDFString,
    isUploadedNewVersionFile
  } = useSelector((store) => store.zone);

  const countryList = countrySiteList.country.filter(function (item) {
    return docDetailsList?.countriesid?.indexOf(item.id) !== -1;
  });
  const siteList = countrySiteList.site.filter(function (item) {
    return docDetailsList?.sitesid?.indexOf(item.id) !== -1;
  });
  const {
    requestPayload,
    previewFileURL,
    fileName,
    fileType,
    previewLoading,
    downLoader,
    downloadingFiles,
    singleFile,
    isScanning,
    saveChanges,
    fileErrorMessage,
    singleFileErrorMessage,
  } = useSelector((store) => store.file);
  const {
    fullDateTimePattern,
    dateLocale,
    settings,
    isEtmfLocked,
    cloneLoading,
    datingConventionList,
  } = useSelector((store) => store.template);
  const {
    documentHistoryList,
    docStatusLoading,
    commentList,
    noteArr,
    documentVersionList,
    selectedDocDetail,
    versionLoader,
    docShareCount,
    metricsLoader,
    historyLoading,
    docStatusChangeInProgress,
    noteResolving,
    docPropErrorMessage,
    isHistoryTriggered  // Added this global state in order to track the history API that were triggered on document status change saga
  } = useSelector((store) => store.document);

  const documentId = !_.isEmpty(documentHistoryList)
  ? documentHistoryList[0]?.documentid
  : "";
  const documentType = UtilsHelper.getFileExtension(
    docDetails?.origfilename || documentHistoryList[0]?.filename
  );

  const documentVersionValueList = documentVersionList?.map((list) => {
    return {
      documentversionguid: list.documentversionguid,
      label: `${t("TMF.TEXT_VERSION")} ${list.label}`,
      value: list.value,
    };
  });

  // eslint-disable-next-line no-unused-vars
  const [commentListArray, setCommentListArray] = useState(commentList);
  const [notesListArray, setNotesListArray] = useState(noteArr);
  const docStatusPayload = {};
  const [documentPayload, setDocumentPayload] = useState({});
  const [completePayload, setCompletePayload] = useState({});
  const datingConvention = datingConventionList.map((item) => item.name);
  const [showDocsharing, setShowDocsharing] = useState(false);
  const [latestVersion, setLatestVersion] = useState("");
  const [isFileUpload, setIsFileUpload] = useState(false);

  const enableDocumentOption = isNewVersionCreated
    ? newVersionType === "upload-version" ?  isUploadedNewVersionFile && !isScanning && tmpGuid :  true
    : true;

  useEffect(() => {
    if (!_.isEmpty(newlyModifiedDocumentData)) {
      onSaveFile();
    }
  }, [newlyModifiedDocumentData]);
  const onSaveFile = async () => {
    documentStatusChangeHandler(docDetailsList, APP_CONST.TEXT_UNPUBLISHED, false, true);
  };

  useEffect(() => {
    setCommentListArray(commentList);
    setNotesListArray(noteArr);
  }, [commentList, noteArr]);

  // Added this below useEffect to initiate history API call in order to render latest history once user added form field in initial unpublished record
  useEffect(() => {
    if (!_.isEmpty(latestDocumentDetails) && !isHistoryTriggered) {
      let rerenderId = "";
      if (docDetailsList.docid !== undefined && docDetailsList.docid !== null) {
        rerenderId = docDetailsList.docid;
      } else {
        rerenderId = "";
      }
      if (rerenderId) {
        var latestDetail = latestDocumentDetails.find(
          (val) => val.docid === rerenderId
        );
        if (!_.isEmpty(latestDetail) && !historyLoading) {
          const payloadData = {
            documentid: latestDetail.documentid,
            lastModifiedOn:
              latestDetail.lastmodifiedon || latestDetail.createdon,
            documentversionguid: latestDetail.documentversionguid,
          };

          dispatch(documentActions.getDocumentHistory(payloadData));
        }
      }
    }
  }, [latestDocumentDetails]);

  useEffect(() => {
    if (
      !["Shared", "Private", undefined, null].includes(docDetailsList?.status)
    ) {
      setIsRelocatingDoc(false);
    }
    if (!_.isEmpty(docPropErrorMessage)) {
      setIsRelocatingDoc(false);
    }
  }, [documentHistoryList, docPropErrorMessage]);

  useEffect(() => {
    if (!_.isEmpty(selectedDocDetail)) {
      selectedDocDetail.documentDetails
        ? setdocDetailsList({
            ...selectedDocDetail.documentDetails,
            reviewPermission: docDetailsList.reviewPermission,
            writePermission: docDetailsList.writePermission,
          })
        : setdocDetailsList({
            ...selectedDocDetail,
            reviewPermission: docDetailsList.reviewPermission,
            writePermission: docDetailsList.writePermission,
          });
    }
  }, [selectedDocDetail]);

  useEffect(() => {
    if (!_.isEmpty(relocatedDoc)) {
      setIsDropZoneDoc(false);
      const reqObject = {
        artifactuseraccess: artifactUserAccess,
        rolePermission: docPermission,
        documenttmflevel: relocatedDoc.documenttmflevel,
        sitesid: relocatedDoc.sitesid,
        countriesid: relocatedDoc.countriesid,
        countrySiteList,
      };
      const permissionObject = UtilsHelper.permissionObject(reqObject);

      !_.isEmpty(relocatedDoc) &&
        !_.isEmpty(permissionObject) &&
        setdocDetailsList({
          ...relocatedDoc,
          reviewPermission: permissionObject.reviewPermission,
          writePermission: permissionObject.writePermission,
        });

      setIsDropZoneDoc(false);
    }
  }, [relocatedDoc]);

  useEffect(() => {
    if (!docDetailsList.tmfdropzoneid && !_.isEmpty(relocatedDoc)) {
      setIsDropZoneDoc(false);
      const { documentid, lastmodifiedon, documentversionguid } = relocatedDoc;
      const payloadData = {
        documentid,
        lastModifiedOn: lastmodifiedon,
        documentversionguid,
      };
      !isHistoryTriggered && dispatch(documentActions.getDocumentHistory(payloadData));
    }
  }, [docDetailsList]);

  useEffect(() => {
    if (!_.isEmpty(selectedDocDetail)) return;
    if (from !== "Documents") {
      setdocDetailsList({
        ...docDetails,
        reviewPermission: docDetailsList.reviewPermission,
        writePermission: docDetailsList.writePermission,
      });
    } else {
      setdocDetailsList({ ...docDetails });
    }

    if (from === "Documents" && isDocViewVisible) {
      documentPreviewHandler();
    }
  }, [docDetails]);

  useEffect(() => {
    if (
      docStatusPayload.currentArtiId !== newArtifactId &&
      !_.isEmpty(documentDataList[newArtifactId])
    ) {
      const newLocatedDoc = documentDataList[newArtifactId].find(
        (doc) => doc.documentid === documentId
      );
      _.isEmpty(relocatedDoc) &&
        setdocDetailsList({
          ...newLocatedDoc,
          reviewPermission: docDetailsList.reviewPermission,
          writePermission: docDetailsList.writePermission,
        });
    }
  }, [documentDataList]);

  useEffect(() => {
    //debouncing
    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    };

    const handleMouseDown = (e) => {
      if (
        e.srcElement?.name === "close_in_full" ||
        e.srcElement?.name === "close_fullscreen"
      ) {
      } else {
        handleMouse(false);
      }
    };
    const handleMouseUp = () => {
      handleMouse(true);
    };
    const handleMouse = debounce((value) => {
      setIsNotGragging(value);
    }, 2000);
    const element = document.getElementById("resizeHandle");
    if (element) {
      element.addEventListener("mousedown", handleMouseDown);
      element.addEventListener("mouseup", handleMouseUp);
    }
    return () => {
      if (element) {
        element.removeEventListener("mousedown", handleMouseDown);
        element.removeEventListener("mouseup", handleMouse);
      }
    };
  });

  document.getElementById("resizeHandle")?.addEventListener("mouseup", () => {
    setIsNotGragging(true);
  });

  useEffect(() => {
    if (
      isDocVisible === false &&
      previewFileURL !== "" &&
      previewFileURL !== undefined &&
      docDetails.documentid === requestPayload?.documentid
    ) {
      setIsDocVisible(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewFileURL]);

  useEffect(() => {
    if (!_.isEmpty(documentVersionList)) {
      const getVersion = documentVersionList.filter(
        (latest) => latest.islatestdocumentversion === true
      );
      if (!_.isEmpty(getVersion[0])) {
        setLatestVersion(getVersion[0].documentversionnumber);
      }
    }
  }, [documentVersionList]);

  const onHide = (e) => {
    dispatch(documentActions.isDocumentstatusChangeHistory(false));
    dispatch(documentActions.clearDocErrorMessage());
    dispatch(fileUploadActions.clearFileErrorMessage());
    dispatch(zoneActions.getDocumentsByArtifactFailed());
    dispatch(documentActions.documentStatusChangeFailed());
    setViewDocumentObj(false);
    setIsDocVisible(false);
    setShowDocDeletePopup(false);
    from === "Documents" && setIsDocViewVisible(false);
    singleFile.uploadingProgress = 0;
    dispatch(fileUploadActions.filePreviewUrlFailed());
    dispatch(documentActions.docClearNote());
    dispatch(documentActions.documentGetReviewFailed());
    dispatch(documentActions.clearDocumentVersionList());
    dispatch(documentActions.getSelectedDocumentDetailFailed());
    dispatch(documentActions.clearBinderMetrics());
    dispatch(zoneActions.toPassModifiedData("", false));
    setIsFileUpload(false);
    setIsDocNewVersionCreated(false);
    isNewVersionCreated && dispatch(zoneActions.isUploadedNewVersionFile(false));
    setTmpGuid(null);
    setTmpFileGuid(null);
  };
  const dialogCloseHandler = (e) => {
    e.target?.renderRoot?.activeElement?.className === "dialog__close-button" &&
      e.target.__optionalClose &&
      setShowCloseConfirmation(true);
  };

  const countryName = docDetailsList?.countriesid?.map((objId, index) => {
    const findObject = _.find(countryList, { id: objId });
    return (
      <div className="cardBox" key={index}>
        {!_.isEmpty(findObject)
          ? `${findObject.description} ${
              countryList.length - 1 === index ? "" : ","
            }`
          : objId}
      </div>
    );
  });
  const siteName = docDetailsList?.sitesid?.map((objId, index) => {
    const findObject = _.find(siteList, { id: objId });
    return (
      <div className="cardBox" key={index}>
        {!_.isEmpty(findObject)
          ? `${findObject.description} ${
              siteList.length - 1 === index ? "" : ","
            }`
          : objId}
      </div>
    );
  });

  const documentInfoList = [
    {
      label: t("DETAILPAGE.LABEL_DOCUMENTNAME"),
      displayValue:
        docStatusChangeInProgress &&
        !_.isEmpty(documentPayload?.documentDetails?.title) ? (
          <viedoc-spinner size="small" class="download__spinner" />
        ) : (
          UtilsHelper.getDocumentName(docDetailsList)
        ),
    },
    {
      label: t("TMF.TEXT_VERSIONLBL"),
      displayValue:
        docStatusChangeInProgress &&
        !_.isEmpty(documentPayload?.documentDetails?.version)
          ? documentPayload?.documentDetails?.version
          : docDetailsList?.version === ""
          ? "---"
          : docDetailsList?.version,
    },
    {
      label: docDetailsList?.datingconventionlabel,
      displayValue:
        docStatusChangeInProgress &&
        !_.isEmpty(documentPayload?.documentDetails?.datingconventiondate)
          ? moment(
              documentPayload?.documentDetails?.datingconventiondate
            ).format("DD MMM YYYY")
          : moment(docDetailsList?.datingconventiondate).format("DD MMM YYYY"),
    },
    {
      label: t("TMF.TEXT_COUNTRYLBL"),
      displayValue:
        docDetailsList?.documenttmflevel === "Country" ? (
          <>{countryName}</>
        ) : (
          "---"
        ),
    },
    {
      label: t("TMF.TEXT_SITELBL"),
      displayValue:
        docDetailsList?.documenttmflevel === "Site" ? <>{siteName}</> : "---",
    },
    { label: t("TMF.TEXT_IDENTIFIER"), displayValue: docDetailsList?.docid },
    {
      label: t("TMF.TEXT_DISPLAYTEMPLATE"),
      displayValue: docDetailsList?.displaytemplate,
    },
    {
      label: t("TMF.TEXT_DOWNLOADTEMPLATE"),
      displayValue: docDetailsList?.downloadtemplate,
    },
    {
      label: t("TMF.TEXT_ARCHIVETEMPLATE"),
      displayValue: docDetailsList?.archivetemplate,
    },
    {
      label: t("TMF.TEXT_TMFSIDE"),
      displayValue:
        docDetailsList?.documenttmfside?.issponsor &&
        docDetailsList?.documenttmfside?.isinvestigator
          ? `${t("TMF.FORMLABEL_SPONSOR")}, ${t("TMF.FORMLABEL_INVESTIGATOR")}`
          : docDetailsList?.documenttmfside?.issponsor ? 
          t("TMF.FORMLABEL_SPONSOR") :
          docDetailsList?.documenttmfside?.isinvestigator
          ? t("TMF.FORMLABEL_INVESTIGATOR")
          : "---",
    },
  ];

  const fileInfoList = [
    {
      label: t("TMF.TEXT_ORIGFILENAMELBL"),
      displayValue: docDetailsList?.origfilename,
    },
    {
      label: t("TMF.TEXT_FILESIZE"),
      displayValue: UtilsHelper.getFileSize(
        docDetailsList?.fileSize || docDetailsList?.filesize
      ),
    },
    {
      label: t("TMF.TEXT_FILEDATELBL"),
      displayValue: fullDateTimePattern
        ? UtilsHelper.getFormattedDateTime(
            fullDateTimePattern,
            docDetailsList?.filedate,
            dateLocale
          )
        : UtilsHelper.momentLocalConversion(docDetailsList?.filedate, true),
    },
    {
      label: t("TMF.TEXT_FILEVERSION"),
      displayValue: docDetailsList?.filesystemversion,
    },
    {
      label: t("TMF.TEXT_INTEGRITYVALUE"),
      displayValue: docDetailsList?.fileintegrity,
    },
  ];

  const saveChangesHandler = () => {
    if (isAwaitingFlagged) {
      callSaveComments();
    }
    const { requiredFields } = docStatusPayload;
    if (
      requiredFields.selectedDocumentType === APP_CONST.SELECT_DOCUMENT_TYPE ||
      requiredFields.selectedScope === APP_CONST.SELECT_SCOPE ||
      requiredFields.selectedZone === APP_CONST.SELECT_ZONE ||
      requiredFields.selectedSection === APP_CONST.SELECT_SECTION ||
      requiredFields.selectedArtifact === APP_CONST.SELECT_ARTIFACT ||
      !requiredFields.versionDate ||
      (!requiredFields.sharingNoneChecked &&
        !requiredFields.clinicalUserChecked &&
        !requiredFields.viedocMeUserChecked)
    ) {
      setShowRequiredWarnings(true);
      setShowToaster(true);
    } else if (
      requiredFields.selectedScope === "Country" &&
      _.isEmpty(requiredFields.selectedCountry)
    ) {
      setShowRequiredWarnings(true);
      setShowToaster(true);
    } else if (
      requiredFields.selectedScope === "Site" &&
      _.isEmpty(requiredFields.selectedSite)
    ) {
      setShowRequiredWarnings(true);
      setShowToaster(true);
    } else if (
      requiredFields.selectedDocumentType === "Other" &&
      (requiredFields.customType === "" || requiredFields.customType === null)
    ) {
      setShowRequiredWarnings(true);
      setShowToaster(true);
    } else if (
      requiredFields.customName &&
      _.isEmpty(requiredFields.customTitle)
    ) {
      setShowRequiredWarnings(true);
      setShowToaster(true);
    } else if (
      !requiredFields.sharingNoneChecked &&
      !requiredFields.clinicalUserChecked &&
      !requiredFields.viedocMeUserChecked &&
      !isAwaitingFlagged
    ) {
      setShowRequiredWarnings(true);
      setShowToaster(true);
    } else {
      if (setDocFilterUsed) setDocFilterUsed(false);
      if (isEditFormTouched) {
        setDocumentPayload(JSON.parse(docStatusPayload?.documentContents));
        setCompletePayload(docStatusPayload);
        docStatusPayload.setdocDetailsList = setdocDetailsList;
        docStatusPayload.workflowAction = "saveChanges";
        docStatusPayload.iscreatenewversionfileupload = isDropZoneDoc
          ? undefined
          : newVersionType === "upload-version";
        setIsEditFormTouched(false);
        setIsEditMode(false);
        setIsEditModeClicked(false);
        setSingleFileUploaded(false);
        dispatch(documentActions.documentStatusChange(docStatusPayload, ""));
      }
    }
    setIsNewVersionCreated(false);
    setTmpGuid(null);
    setTmpFileGuid(null);

    function callSaveComments() {
      const payloadData = {
        actionId: actionId,
        comment: [actionText],
        documentId: docDetailsList?.documentid,
        lastModifiedOn: docDetailsList?.lastmodifiedon,
        documentversionguid: docDetailsList?.documentversionguid,
      };
      payloadData.docDetailsList = docDetailsList;
      dispatch(documentActions.documentSaveReview(payloadData));
      setIsAwaitingFlagged(false);
    }
  };

  const cancelHandler = () => {
    docDetailsList.status = docDetails.status;
    for (let i = addedComments - 1; i >= 0; i--) {
      commentListArray.pop();
    }

    setAddedComments(0);
    setIsAwaitingFlagged(false);
  };

  const editCancelHandler = () => {
    setSingleFileUploaded(false);
    setIsEditModeClicked((prevState) => !prevState);
    setIsEditMode((prevState) => !prevState);
    if (isScanning || saveChanges) {
      if (tmpGuid && tmpGuid !== undefined) {
        dispatch(fileUploadActions.createNewDocVersionCancel(tmpGuid));
      }
    }
    setIsEditFormTouched(false);
    if (isNewVersionCreated) {
      documentVersionList.splice(0, 1);
      setIsNewVersionCreated((prevState) => !prevState);
      setdocDetailsList(docDetails);
      setShowRequiredWarnings(false);
      setShowToaster(false);
      setIsActionLoading(false);
      setIsDocVisible(false);
      setIsDocNewVersionCreated(false);
      dispatch(zoneActions.isUploadedNewVersionFile(false));
    }
    setTmpGuid(null);
    setTmpFileGuid(null);
    singleFile.uploadingProgress = 0;
    dispatch(zoneActions.setDocNewVersionXfdfString(""));
  };

  const versionHandler = (versionId) => {
    const payloadData = {
      documentid: docDetailsList?.documentid,
      documentversionguid: versionId,
    };
    const checkDocLatestVersion = documentVersionList?.find(
      (versionList) => versionList.documentversionguid === versionId
    );
    setLatestDocVersion(checkDocLatestVersion?.islatestdocumentversion);
    dispatch(documentActions.getSelectedDocumentDetail(versionId, payloadData));
  };

  const getCategory = (category) => {
    switch (category) {
      case "Shared":
        return t("TMF.DROPZONELABEL_SHARED");
      case "Private":
        return t("TMF.DROPZONELABEL_PRIVATE");
      default:
        return "";
    }
  };

  const renderHeaderDocumentView = () => {
    return (
      <header slot="header">
        <h2 className="document-header pl-10 mr-10">
          {isDropZoneDoc
            ? _.isEmpty(docDetails?.category)
              ? t("TMF.TEXT_DOCUMENTPROP")
              : t("TMF.DROPZONELABEL_DROPZONE") +
                " [" +
                getCategory(docDetails?.category) +
                "]"
            : isNewVersionCreated
            ? t("TMF.BUTTON_CREATE_NEW_VERSION")
            : t("TMF.TEXT_DOCUMENTPROP")}
        </h2>

        {documentVersionList?.length > 1 && !isNewVersionCreated && (
          <ViedocSelectElement
            size="small"
            variant="filled"
            onChange={(e) => versionHandler(e.target.value)}
          >
            {documentVersionValueList.map((version) => (
              <ViedocMenuItemElement
                key={version.value}
                value={version.documentversionguid}
                size="small"
              >
                {version.label}
              </ViedocMenuItemElement>
            ))}
          </ViedocSelectElement>
        )}
        {!docStatusChangeInProgress && (
          <>
            {!fullDocument &&
              (docDetailsList?.status === APP_CONST.TEXT_UNPUBLISHED ||
                !docDetailsList?.status ||
                ["Shared", "Private"].includes(docDetailsList?.status)) &&
              newVersionType !== "upload-version" && (
                <div className="document-header-button ml-auto">
                  {!isEtmfLocked &&
                    (docDetailsList?.writePermission || isDropZoneDoc) &&
                    !isRelocatingDoc && (
                      <ViedocButtonElement
                        size="small"
                        onClick={() =>changeStatusAction()}
                        title ={t("TMF.BUTTON_PUBLISHBTN")}
                      >
                        {t("TMF.BUTTON_PUBLISHBTN")}
                      </ViedocButtonElement>
                    )}
                  {isEditFormTouched &&
                    (!isNewVersionCreated || isDropZoneDoc) && (
                      <ViedocButtonElement
                        size="small"
                        onClick={() => changeStatusAction(APP_CONST.TEXT_UNPUBLISHED)}
                        title={t("TMF.BUTTON_SAVEUNPUBLISHBTN")}
                      >
                        {t("TMF.BUTTON_SAVEUNPUBLISHBTN")}
                      </ViedocButtonElement>
                    )}
                </div>
              )}

            {!fullDocument &&
              ![APP_CONST.TEXT_FINALIZED, APP_CONST.TEXT_UNPUBLISHED].includes(
                docDetailsList?.status
              ) &&
              !isDropZoneDoc && (
                <div className="document-header-button ml-auto">
                  {docDetailsList?.status !== APP_CONST.TEXT_UNPUBLISHED &&
                    isEditFormTouched && (
                      <ViedocButtonElement
                        size="small"
                        onClick={saveChangesHandler}
                        title={t("ADMIN.BUTTON_SAVECHANGEBTN")}
                      >
                        {t("ADMIN.BUTTON_SAVECHANGEBTN")}
                      </ViedocButtonElement>
                    )}
                  {isAwaitingFlagged && (
                    <ViedocButtonElement
                      size="small"
                      onClick={saveChangesHandler}
                      title={t("ADMIN.BUTTON_SAVECHANGEBTN")}
                    >
                      {t("ADMIN.BUTTON_SAVECHANGEBTN")}
                    </ViedocButtonElement>
                  )}
                  {!isEtmfLocked &&
                    !versionLoader &&
                    docDetailsList.writePermission && (
                      <>
                        {!isAwaitingFlagged ? (
                          <ViedocButtonElement
                            size="small"
                            onClick={() => editCancelHandler()}
                            title={!isRelocatingDoc && isEditMode
                              ? t("TMF.BUTTON_CANCELBTN")
                              : t("TMF.BUTTON_EDITBTN")}
                          >
                            {!isRelocatingDoc && isEditMode
                              ? t("TMF.BUTTON_CANCELBTN")
                              : t("TMF.BUTTON_EDITBTN")}
                          </ViedocButtonElement>
                        ) : (
                          <ViedocButtonElement
                            size="small"
                            onClick={() => cancelHandler()}
                            title={t("TMF.BUTTON_CANCELBTN")}
                          >
                            {t("TMF.BUTTON_CANCELBTN")}
                          </ViedocButtonElement>
                        )}
                      </>
                    )}
                </div>
              )}
            {docDetailsList?.status === APP_CONST.TEXT_UNPUBLISHED && (
              <div
                className={`document-header-button ${
                  newVersionType === "upload-version" ? "ml-auto" : ""
                }`}
              >
                {isNewVersionCreated &&
                  newVersionType === "upload-version" &&
                  singleFile.uploadingProgress === 99 && (
                    <ViedocButtonElement
                      size="small"
                      onClick={() =>changeStatusAction()}
                      title={t("TMF.BUTTON_PUBLISHBTN")}
                    >
                      {t("TMF.BUTTON_PUBLISHBTN")}
                    </ViedocButtonElement>
                  )}
                {isNewVersionCreated && !cloneLoading && (
                  <ViedocButtonElement
                    className={
                      (!singleFile.uploadingProgress ||
                        singleFile.uploadingProgress < 100) &&
                      newVersionType === "upload-version"
                        ? "ml-auto"
                        : newVersionType === "copy-version"
                        ? "ml-0"
                        : ""
                    }
                    size="small"
                    onClick={() => editCancelHandler()}
                    title={t("TMF.BUTTON_CANCELBTN")}
                  >
                    {t("TMF.BUTTON_CANCELBTN")}
                  </ViedocButtonElement>
                )}
              </div>
            )}
          </>
        )}
      </header>
    );
  };

  const documentPreviewHandler = () => {
    if (!isDocVisible) {
      const origfilename = docDetailsList?.origfilename
        ? docDetailsList?.origfilename?.split(`.${docDetailsList?.type}`)[0]
        : docDetailsList?.filename?.split(
            `.${docDetails.dropzoneext || docDetailsList?.fileextension}`
          )[0];
      const uploadNewversionFileName = !_.isEmpty(singleFileDetail) ? singleFileDetail[0].name.split(`.${UtilsHelper.getFileExtension(singleFileDetail[0].name)}`)[0] : ""
      const downloadFileName =
        docDetailsList?.title === "customName"
          ? docDetailsList?.customTitle
          : APP_CONST.TITLE_ARRAY?.includes(docDetailsList?.title)
          ? docDetailsList?.documenttypevalue || docDetailsList?.artifact
          : isNewVersionCreated && tmpGuid ? uploadNewversionFileName : origfilename;
      const displayOrder = UtilsHelper.constructDisplayOrder(
        docDetailsList?.status
      );
      const fileProps = {
        ...docDetailsList,
        downloadFileName,
        displayOrder: displayOrder,
      };
      if(docDetailsList?.tmfdropzoneid && from !== "Documents"){
        fileProps.fileextension = docDetailsList?.fileextension?.toLowerCase();
      } else {
        fileProps.type = docDetailsList?.type?.toLowerCase();
      }
      dispatch(
        fileUploadActions.filePreviewUrl(
          UtilsHelper.prepareDownloadReq(fileProps),
          isDropZoneDoc ? true : false,
          false,
          fileProps.documentversionguid,
          isNewVersionCreated && tmpGuid ? tmpGuid : "",
          isNewVersionCreated && tmpGuid ? singleFileDetail[0].name : "",
        )
      );
    }
    const {
      fileguid,
      documentid,
      lastmodifiedon,
      documentversionguid,
      createdon,
    } = docDetailsList;
    const lastModifiedOn = lastmodifiedon ? lastmodifiedon : createdon;
    const payloadData = {
      documentid: isDropZoneDoc ? fileguid : documentid,
      lastModifiedOn,
      documentversionguid: isDropZoneDoc
        ? APP_CONST.HARD_CODED.dummyId
        : documentversionguid,
    };
    dispatch(documentActions.getDocumentHistory(payloadData));
    setIsDocVisible(!isDocVisible);
    dispatch(zoneActions.setDocNewVersionXfdfString(""));
    unSavedFormFields.current={}
  };

  const docList = (documentData) => {
    const fileType = isDropZoneDoc
      ? docDetails.dropzoneext || docDetails.fileextension
      : docDetailsList?.type;
    let assign = "";
    switch (fileType) {
      case "xlsx":
        assign = "xlsx";
        break;
      case "xls":
        assign = "xlsx";
        break;
      case "pdf":
        assign = "pdf";
        break;
      case "docx":
        assign = "docx";
        break;
      case "tiff":
        assign = "tiff";
        break;
      case "tif":
        assign = "tiff";
        break;
      case "jpg":
        assign = "tiff";
        break;
      case "jepg":
        assign = "tiff";
        break;
      case "gif":
        assign = "tiff";
        break;
      case "png":
        assign = "tiff";
        break;
      case "bmp":
        assign = "tiff";
        break;
      case "txt":
        assign = "txt";
        break;
      case "rtf":
        assign = "txt";
        break;
      case "zip":
        assign = "zip";
        break;
      case "xml":
        assign = "xml";
        break;
      case "yml":
        assign = "yml";
        break;
      case "html":
        assign = "yml";
        break;
      case "htm":
        assign = "yml";
        break;
      case "PPTX":
        assign = "pptx";
        break;
      case "PPT":
        assign = "pptx";
        break;
      case "MP4":
        assign = "mp4";
        break;
      default:
        break;
    }
    return assign;
  };

  const renderDownloadIcon = (docDetailsList) => {
    return (
      <div
        className="close-button"
        title={t("TMF.TEXT_DOWNLOAD")}
        onClick={() => onDownloadIconClick(docDetailsList, true)}
      >
        {downLoader && docDetailsList.docid === downloadingDocId ? (
          <viedoc-spinner size="small" class="spinner"></viedoc-spinner>
        ) : (
          <viedoc-icon name="download"></viedoc-icon>
        )}
      </div>
    );
  };

  const renderFileHeader = () => {
    return (
      <div className="document-file-header">
        <div
          className={`document-file-type
          ${docList(docDetailsList)}`}
        >
          {isDropZoneDoc
            ? docDetails.dropzoneext || docDetails.fileextension
            : docDetailsList?.type}
        </div>
        <div className="document-file-content">
          <p>
            {isDropZoneDoc
              ? docDetailsList?.filename
              : docDetailsList?.displaytemplate}
          </p>
          {docDetailsList?.islocked && <viedoc-icon name="lock" />}
        </div>
        {enableDocumentOption && (
          <div className="document-file-button">
            {apiInitConfigObj.previewsupportedfiletypes.includes(
              documentType
            ) ? (
              <div
                className="close-button"
                onClick={() => documentPreviewHandler()}
              >
                {previewLoading ? (
                  <viedoc-spinner size="small" class="spinner"></viedoc-spinner>
                ) : (
                  <viedoc-icon
                    name="visibility"
                    title={t("TMF.TEXT_PREVIEW")}
                  />
                )}
              </div>
            ) : (
              <div className="no-preview">
                <viedoc-icon
                  name="visibility_off"
                  title={t("TMF.TEXT_PREVIEWNOTALLOW")}
                ></viedoc-icon>
              </div>
            )}

            {((docDetailsList?.status !== "Scanning in progress" &&
              docDetailsList?.artifact !== null)|| docDetailsList?.tmfdropzoneid) &&
              renderDownloadIcon(docDetailsList)}
            {(docDetailsList?.status === APP_CONST.TEXT_UNPUBLISHED ||
              isDropZoneDoc) &&
              !isEtmfLocked &&
              !isNewVersionCreated &&
              (docDetailsList.writePermission || isDropZoneDoc) && (
                <viedoc-icon
                  class="close-button"
                  name="delete_bin"
                  title="Delete"
                  onClick={() => {
                    setShowDocDeletePopup(true);
                    setSectionOrigid(docDetailsList?.sectionid);
                    setDocDeleteData({
                      ...docDeleteData,
                      id: isDropZoneDoc
                        ? docDetailsList.tmfdropzoneid
                        : docDetailsList?.documentid,
                      category: isDropZoneDoc ? docDetailsList?.category : "",
                      lastModifiedOn:
                        docDetailsList?.lastmodifiedon ||
                        docDetailsList?.createdon,
                      fileName: isDropZoneDoc
                        ? docDetailsList.filename
                        : docDetailsList?.origfilename,
                    });
                  }}
                />
              )}
          </div>
        )}
      </div>
    );
  };

  const iconList = (documentData) => {
    let icon = "";
    switch (documentData?.status) {
      case APP_CONST.TEXT_UNPUBLISHED:
        icon = "block";
        break;
      case APP_CONST.TEXT_FINALIZED:
        icon = "check";
        break;
      case APP_CONST.TEXT_AWAITINGREVIEW:
        icon = "load";
        break;
      case APP_CONST.TEXT_FLAGGEDBYQC:
        icon = "flag";
        break;
      default:
        break;
    }
    return icon;
  };

  const closeFormFieldErrPopup = (e) => {
    e.stopPropagation();
    setShowFormField({...showFormField, isOpen:false, recordStatus : ""});
  }

  const triggerStatusChangeHandler = (recordStatus = "") => {
    recordStatus === APP_CONST.TEXT_UNPUBLISHED
      ? documentStatusChangeHandler(
          docDetailsList,
          APP_CONST.TEXT_UNPUBLISHED,
          true
        )
      : documentStatusChangeHandler(
          docDetailsList,
          isNewVersionCreated ? "saveChanges" : APP_CONST.TEXT_PUBLISH
        );
  };

  const changeRecordStatus = (e) => {
    triggerStatusChangeHandler(showFormField.recordStatus);
    closeFormFieldErrPopup(e);
  };

  const renderFormFieldError = () => {
    return (
       <ViedocDialogElement id="doc-delete" size="small" open preventCloseByClick onHide={(e) => closeFormFieldErrPopup(e)}>
            <header slot="header">
              <p className="f21">{t("TMF.TEXT_WARNING")}</p>
            </header>
            <main className="delete-document">
              <div className="delete-icon alert-icon">
                <viedoc-icon name="warning"></viedoc-icon>
              </div>
              <div className="delete-option">
                <label>{showFormField.recordStatus === APP_CONST.TEXT_UNPUBLISHED ? t("TMF.TEXT_UNPUBLISH_FORMFIELD_ERROR") : t("TMF.TEXT_PUBLISH_FORMFIELD_ERROR")}</label>
                <div className="pt-20">
                  <ViedocButtonElement
                    class="mr-10"
                    variant="neutral"
                    size="small"
                    onClick={ (e) => changeRecordStatus(e)}
                  >
                    {showFormField.recordStatus === APP_CONST.TEXT_UNPUBLISHED ? t("TMF.BUTTON_SAVEUNPUBLISHBTN") : t("TMF.BUTTON_PUBLISHBTN")}
                  </ViedocButtonElement>
                  <ViedocButtonElement
                    class="mr-10"
                    variant="neutral"
                    size="small"
                    onClick={(e) => closeFormFieldErrPopup(e)}
                  >
                    {t("TMF.BUTTON_CANCELBTN")}
                  </ViedocButtonElement>
                </div>
              </div>
            </main>
          </ViedocDialogElement>
    );
  };

  const changeStatusAction = (recordStatusData = "") => {
    if(!_.isEmpty(unSavedFormFields.current) && Object.keys(unSavedFormFields.current).length > 0){
      setShowFormField({...showFormField, isOpen:true, recordStatus : recordStatusData});
    } else {
      triggerStatusChangeHandler(recordStatusData);
    }
  };

  const documentStatusChangeHandler = (
    docDetailsList,
    action,
    isFormSave = false,
    fromPreview
  ) => {
    dispatch(fileUploadActions.singleFileErrorToaster(""));
    if (setDocFilterUsed) setDocFilterUsed(false);
    setIsActionLoading(true);
    let payloadData = {};
    if (action === APP_CONST.TEXT_LOCK) {
      payloadData.documentId = docDetailsList?.documentid ? docDetailsList?.documentid : docDetailsList?.documentguid;
      payloadData.sectionId = docDetailsList?.sectionid;

      payloadData.origiartifactid = docDetailsList?.origiartifactid;
      payloadData.lastmodifiedon = docDetailsList?.lastmodifiedon;
      payloadData.documentversionguid = docDetailsList?.documentversionguid;
      payloadData.setIsActionLoading = setIsActionLoading;
      payloadData.setdocDetailsList = setdocDetailsList;
      payloadData.docDetailsList = docDetailsList;
      dispatch(documentActions.fetchDocumentLock(payloadData));
    } else if (action === APP_CONST.TEXT_UNPUBLISHED) {
      setDocumentPayload(JSON.parse(docStatusPayload.documentContents));
      setCompletePayload(docStatusPayload);

      setIsEditFormTouched(false);
      setSingleFileUploaded(false);
      !fromPreview && setIsDocVisible(false);
      unSavedFormFields.current = {};
      if (!_.isEmpty(newlyModifiedDocumentData) && !isFormSave) {
        let docStatusPayloadUpdated = {
          ...docStatusPayload,
          isdocumentcustomized: true,
          xfdfstring: encodeURIComponent(newlyModifiedDocumentData),
        };
        dispatch(documentActions.isDocumentstatusChangeHistory(false)); // Added this action in order to execute the history API call to get latest history once user added form field.
        dispatch(
          documentActions.documentStatusChange(
            docStatusPayloadUpdated,
            isDropZoneDoc ? docStatusPayloadUpdated.category : ""
          )
        );
        setResetFormToInitial(true);
      } else {
        let docPayloadUpdated = {
          ...docStatusPayload,
          isdocumentcustomized: false,
        };
        dispatch(
          documentActions.documentStatusChange(
            docPayloadUpdated,
            isDropZoneDoc ? docStatusPayload.category : ""
          )
        );
        setShowRequiredWarnings(false);
        setShowToaster(false);
      }
      if (docDetailsList?.tmfdropzoneid) {
        setIsRelocatingDoc(true);
      }
    } else if (action === APP_CONST.TEXT_PUBLISH || action === "saveChanges") {
      dispatch(documentActions.getSelectedDocumentDetailFailed());
      setDocumentPayload(JSON.parse(docStatusPayload.documentContents));
      setCompletePayload(docStatusPayload);
      const { requiredFields } = docStatusPayload;
      if (
        requiredFields.selectedDocumentType ===
          APP_CONST.SELECT_DOCUMENT_TYPE ||
        requiredFields.selectedScope === APP_CONST.SELECT_SCOPE ||
        requiredFields.selectedZone === APP_CONST.SELECT_ZONE ||
        requiredFields.selectedSection === APP_CONST.SELECT_SECTION ||
        requiredFields.selectedArtifact === APP_CONST.SELECT_ARTIFACT ||
        !requiredFields.versionDate ||
        (!requiredFields.sharingNoneChecked &&
          !requiredFields.clinicalUserChecked &&
          !requiredFields.viedocMeUserChecked)
      ) {
        setShowRequiredWarnings(true);
        setShowToaster(true);
      } else if (
        requiredFields.selectedScope === "Country" &&
        _.isEmpty(requiredFields.selectedCountry)
      ) {
        setShowRequiredWarnings(true);
        setShowToaster(true);
      } else if (
        requiredFields.selectedScope === "Site" &&
        _.isEmpty(requiredFields.selectedSite)
      ) {
        setShowRequiredWarnings(true);
        setShowToaster(true);
      } else if (
        requiredFields.selectedDocumentType === "Other" &&
        (requiredFields.customType === "" || requiredFields.customType === null)
      ) {
        setShowRequiredWarnings(true);
        setShowToaster(true);
      } else if (
        requiredFields.customName &&
        _.isEmpty(requiredFields.customTitle)
      ) {
        setShowRequiredWarnings(true);
        setShowToaster(true);
      } else if (
        !requiredFields.sharingNoneChecked &&
        !requiredFields.clinicalUserChecked &&
        !requiredFields.viedocMeUserChecked
      ) {
        setShowRequiredWarnings(true);
        setShowToaster(true);
      } else {
        docStatusPayload.workflowState = isDropZoneDoc
          ? "unpublished"
          : docDetailsList?.status;
        docStatusPayload.workflowAction =
          action === "saveChanges" ? "saveChanges" : "publish";
        docStatusPayload.iscreatenewversionfileupload = isDropZoneDoc
          ? undefined
          : isNewVersionCreated && tmpGuid ? true : newVersionType === "upload-version";
        docStatusPayload.docDetailsList.status = APP_CONST.TEXT_AWAITINGREVIEW;
        docStatusPayload.setIsActionLoading = setIsActionLoading;
        docStatusPayload.setdocDetailsList = setdocDetailsList;
        setShowRequiredWarnings(false);
        setShowToaster(false);
        setIsEditFormTouched(false);
        setIsEditMode(false);
        setIsEditModeClicked(false);
        if (docDetailsList?.tmfdropzoneid && !showRequiredWarnings) {
          setIsRelocatingDoc(true);
        }
        if (
          isNewVersionCreated &&
          docNewVersionXFDFString !== ""
        ) {
          docStatusPayload.isformfieldadded = true;
          docStatusPayload.formfielddata = encodeURIComponent(
            docNewVersionXFDFString
          );
        }
        if(isNewVersionCreated) {
        setIsDocVisible(false);  
        setIsDocNewVersionCreated(false);
        dispatch(zoneActions.isUploadedNewVersionFile(false));
        }
        dispatch(
          documentActions.documentStatusChange(
            docStatusPayload,
            isDropZoneDoc ? docStatusPayload.category : ""
          )
        );
        setIsNewVersionCreated(false);
        setIsDocVisible(false);
        unSavedFormFields.current = {};
      }
      setSingleFileUploaded(false);
      setTmpGuid(null);
      setTmpFileGuid(null);
    } else {
      payloadData.documentId = docDetailsList?.documentid;
      payloadData.sectionId = docDetailsList?.sectionid;

      payloadData.origiartifactid = docDetailsList?.origiartifactid;
      payloadData.lastmodifiedon = docDetailsList?.lastmodifiedon;
      payloadData.workflowState = docDetailsList?.status;
      payloadData.workflowAction = action;
      payloadData.documentversionguid = docDetailsList?.documentversionguid;
      payloadData.setIsActionLoading = setIsActionLoading;
      payloadData.setdocDetailsList = setdocDetailsList;
      payloadData.docDetailsList = docDetailsList;
      dispatch(
        documentActions.documentStatusChange(
          payloadData,
          "",
          settings.islockdoconapproveenabled
        )
      );
    }
    singleFile.uploadingProgress = 0;
  };

  const renderActionButton = (docDetailsList) => {
    let button = null;
    switch (docDetailsList?.status) {
      case APP_CONST.TEXT_UNPUBLISHED:
        break;

      case APP_CONST.TEXT_FINALIZED:
        button = docDetailsList.reviewPermission && (
          <ViedocButtonElement
            variant={isActionLoading ? "neutral" : "secondary"}
            size="small"
            class={
              docDetailsList.islocked && settings?.isreasonforunlockdocenabled
                ? "hide-button"
                : "approve"
            }
            onClick={() =>
              documentStatusChangeHandler(docDetailsList, APP_CONST.TEXT_LOCK)
            }
            title = {!isActionLoading ? docDetailsList.islocked ? t("TMF.REVIEWPOPUP_UNLOCK") : t("TMF.REVIEWPOPUP_LOCK") : ""}
          >
            <div className="d-flex jc-center align-center">
              {isActionLoading ? (
                <viedoc-spinner></viedoc-spinner>
              ) : docDetailsList.islocked ? (
                t("TMF.REVIEWPOPUP_UNLOCK")
              ) : (
                t("TMF.REVIEWPOPUP_LOCK")
              )}
            </div>
          </ViedocButtonElement>
        );
        break;

      case APP_CONST.TEXT_FLAGGEDBYQC:
        break;

      case APP_CONST.TEXT_AWAITINGREVIEW:
        button = docDetailsList.reviewPermission && (
          <ViedocButtonElement
            variant={isActionLoading ? "neutral" : "success"}
            size="small"
            class="approve"
            onClick={() =>
              documentStatusChangeHandler(docDetailsList, "Approve")
            }
            title={!isActionLoading ? t("TMF.TEXT_APPROVE") : ""}
          >
            {isActionLoading ? (
              <viedoc-spinner></viedoc-spinner>
            ) : (
              t("TMF.TEXT_APPROVE")
            )}
          </ViedocButtonElement>
        );
        break;

      default:
        break;
    }
    return docDetailsList?.status !== APP_CONST.TEXT_UNPUBLISHED && button;
  };

  const displayLatestActionOnFile = () => {
    let status = documentHistoryList[0]?.status;
    let fileName = documentHistoryList[0]?.filename;
    let createdOn = documentHistoryList[0]?.createdon;
    let uploadedOn = documentHistoryList[0]?.uploadedon;
    let recipientCount = documentHistoryList[0]?.recipientcount;
    let coSignatoriesCount = documentHistoryList[0]?.cosignatorycount;
    let username =
      documentHistoryList[0]?.username === ""
        ? UtilsHelper.findUserName(userList, documentHistoryList[0]?.userid)
        : documentHistoryList[0]?.username;
    let binderId = documentHistoryList[0]?.binderid;
    let reason = documentHistoryList[0]?.reason;
    let historyData = {
      createdon: createdOn,
      username: username,
      binderid: binderId,
    };
    switch (status) {
      case "Previewed":
        return `${t("TMF.TEXT_PREVIEWED")} ${fileName} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                createdOn,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(createdOn, true)
        } ${t("TMF.TEXT_BY")} ${username} ${t("TMF.TEXT_THATWASUPLOAD")} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                uploadedOn,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(uploadedOn, true)
        }`;

      case "Modified":
        return `${t("TMF.TEXT_LASTMODIFIED")} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                createdOn,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(createdOn, true)
        } ${t("TMF.TEXT_BY")} ${username}`;

      case "shared":
        return `${t("TMF.TEXT_ARECORD")} ( ${t(
          "TMF.LABEL_BINDERID"
        )}: ${binderId} ) ${t("TMF.TEXT_WASSHARED")} ${t(
          "TMF.TEXT_WITH"
        )} ${recipientCount} ${
          recipientCount === 1
            ? t("TMF.TEXT_RECIPIENT")
            : t("TMF.TEXT_LOWEERCASERECIPIENTS")
        } ${
          coSignatoriesCount > 0
            ? `${t("TMF.TEXT_AND")} ${coSignatoriesCount} ${
                coSignatoriesCount > 1
                  ? t("TMF.TEXT_PLURALCOSIGN")
                  : t("TMF.TEXT_SINGULARCOSIGN")
              }`
            : ""
        } ${t("TMF.TEXT_ON")} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                createdOn,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(createdOn, true)
        } ${t("TMF.TEXT_BY")} ${username}`;

      case "SharingRecalled":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_SHARINGREVOKED")} ( ${t(
              "TMF.LABEL_BINDERID"
            )}: ${binderId} ) ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    createdOn,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(createdOn, true)
            } ${t("TMF.TEXT_BY")} ${username}`}
          </p>
        );

      case "viewed":
        return (
          <p className="history-view">
            {`${t("COMMON.TEXT_DOCUMENT")} ( ${t(
              "TMF.LABEL_BINDERID"
            )}: ${binderId} ) ${t("TMF.TEXT_VIEWED")} ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    createdOn,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(createdOn, true)
            }  ${t("TMF.TEXT_BY")} ${username}`}
          </p>
        );

      case "signed":
        return (
          <p className="history-view">
            {`${username} ${t("TMF.TEXT_SIGNED")} ( ${t(
              "TMF.LABEL_BINDERID"
            )}: ${binderId} ) ${t("TMF.TEXT_WITHONETIMECODE")} ${t(
              "TMF.TEXT_ON"
            )} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    createdOn,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(createdOn, true)
            } ${t("TMF.TEXT_WITHREASON")} "${t(
              `TMF.${UtilsHelper.getSignReasonTranslateKey(reason)}`
            )}"`}
          </p>
        );

      case "downloadsharingdetails":
        return (
          <p className="history-view">{`${t("COMMON.TEXT_DOCUMENT")} ( ${t(
            "TMF.LABEL_BINDERID"
          )}: ${binderId} ) ${t("TMF.TEXT_DOWNLOADEDWITHSHARING")} ${t(
            "TMF.TEXT_ON"
          )} ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  createdOn,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(createdOn, true)
          } ${t("TMF.TEXT_BY")} ${username}`}</p>
        );

      case "downloaded":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_ORIGINALFILEDOWNLOADED")} ( ${t(
              "TMF.LABEL_BINDERID"
            )}: ${binderId} ) | ${fileName} ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    createdOn,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(createdOn, true)
            } ${t("TMF.TEXT_BY")} ${username}`}
          </p>
        );

      case "downloadwithsignature":
        return (
          <p className="history-view">{`${t("COMMON.TEXT_DOCUMENT")} ${t(
            "TMF.TEXT_DOWNLOADEDSIGNATURE"
          )} ( ${t("TMF.LABEL_BINDERID")}: ${binderId} ) ${t("TMF.TEXT_ON")} ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  createdOn,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(createdOn, true)
          } ${t("TMF.TEXT_BY")} ${username}`}</p>
        );

      case "Unpublished":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_FORMCONTROLADDED")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    createdOn,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(createdOn, true)
            }  ${t("TMF.TEXT_BY")} ${username}`}
          </p>
        );

      case "CloneFormFile":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_NEWDOCVERSIONFORMCONTROLADDED")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    createdOn,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(createdOn, true)
            }  ${t("TMF.TEXT_BY")} ${username}`}
          </p>
        );

      case "notesadded":
        return renderbinderHistory(historyData, t("TMF.TEXT_DOCUMENTADDED"));
      case "notesupdated":
        return renderbinderHistory(historyData, t("TMF.TEXT_DOCUMENTUPDATED"));
      case "notesdeleted":
        return renderbinderHistory(historyData, t("TMF.TEXT_DOCUMENTDELETED"));
      case "downloadwithnotes":
        return renderbinderHistory(
          historyData,
          t("TMF.TEXT_DOWNLOADEDNOTES"),
          true
        );

      default:
        return `${getStatus(status)} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                documentHistoryList[0]?.lastmodifiedon
                  ? documentHistoryList[0]?.lastmodifiedon
                  : documentHistoryList[0]?.createdon,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(
                documentHistoryList[0]?.lastmodifiedon
                  ? documentHistoryList[0]?.lastmodifiedon
                  : documentHistoryList[0]?.createdon,
                true
              )
        } ${t("TMF.TEXT_BY")} ${username}`;
    }
  };

  const getStatus = (status) => {
    switch (status) {
      case APP_CONST.TEXT_FINALIZED:
        return t("TMF.TEXT_FINALIZED");
      case APP_CONST.TEXT_AWAITINGREVIEW:
        return t("TMF.TEXT_AWAITING");
      case APP_CONST.TEXT_UNPUBLISHED:
        return t("TMF.TEXT_UNPUBLISHED");
      case APP_CONST.TEXT_FLAGGEDBYQC:
        return t("TMF.TEXT_FLAGGEDBYQC");
      case "Document unlocked":
        return t("TMF.TEXT_DOCUMENTUNLOCKED");
      case "Document locked":
        return t("TMF.TEXT_DOCUMENTLOCKED");
      case "Uploaded as Unpublished":
        return t("TMF.TEXT_UPLOADUNPUBLISHED");
      case "Saved as Unpublished":
        return t("TMF.TEXT_SAVEDUNPUBLISHED");
      case "Uploaded to drop zone":
        return t("TMF.TEXT_UPLOADEDDROPZONE");
      default:
        return status;
    }
  };

  const renderTextFieldValues = () => {
    return (
      <>
        <div className="pb-20">
          <div className="light-grey f14">
            {docStatusLoading ? (
              <div className="d-flex gap-8">
                <viedoc-spinner
                  size="small"
                  class="download__spinner"
                ></viedoc-spinner>
                <span>{t("TMF.TEXT_LOADING")}</span>
              </div>
            ) : isNewVersionCreated ? (
              `${t("TMF.TEXT_CREATINGDOCUMENTVERSION")} ${
                docDetailsList.documentsystemversion
              }...`
            ) : (
              displayLatestActionOnFile()
            )}
          </div>
        </div>
        <div className="approval-details-list">
          {!isDropZoneDoc && (
            <viedoc-icon name={iconList(docDetailsList)}></viedoc-icon>
          )}
          <p>
            {isDropZoneDoc
              ? t("TMF.TEXT_INDROPZONE")
              : getStatus(docDetailsList?.status)}
          </p>
          {!isEtmfLocked && !isReadOnlyUser && (
            <div className="document-button">
              {docStatusChangeInProgress ? (
                <viedoc-spinner />
              ) : (
                <>
                  {!isEtmfLocked &&
                    latestDocVersion &&
                    !isRelocatingDoc &&
                    !selectedArtifactDetails?.isdeleted &&
                    !isEditMode &&
                    renderActionButton(docDetailsList)}
                  {!isEtmfLocked &&
                    !isReadOnlyUser &&
                    (docDetailsList?.writePermission ||
                      docDetailsList?.reviewPermission ||
                      isDropZoneDoc) &&
                    !metricsLoader && (
                      <div
                        className="awiting-option"
                        onClick={() =>
                          docDetailsList?.status ===
                            APP_CONST.TEXT_AWAITINGREVIEW ||
                          docDetailsList?.status === APP_CONST.TEXT_FLAGGEDBYQC
                            ? !isEditMode
                              ? documentActionUnlock()
                              : null
                            : documentActionUnlock()
                        }
                        title={t("TMF.TEXT_RECORDACTIONS")}
                      >
                        <span>...</span>
                      </div>
                    )}
                </>
              )}
            </div>
          )}
        </div>
      </>
    );
  };

  const renderCommentSection = () => {
    return (
      docDetailsList?.status === APP_CONST.TEXT_FLAGGEDBYQC && (
        <div className="status-row">
          <div className="comment-box">
            {commentListArray
              .slice(0)
              .reverse()
              .map((comment, index) => {
                return (
                  <Fragment key={index}>
                    <p className="comment-section">
                      <span>
                        {`${t("TMF.TEXT_COMMENT")} #${
                          commentListArray.length - index
                        } :`}{" "}
                      </span>
                      <span>{comment.comment}</span>
                    </p>
                  </Fragment>
                );
              })}
          </div>
        </div>
      )
    );
  };

  const payload = {
    searchKey: "",
    site: "ALL",
    countryCode: "ALL",
    pageCount: 0,
    pageSize: 20000,
    pageNumber: 1,
    artifactId: "",
    sectionid: "",
    category: "",
    milestoneGroup: "ALL",
    milestoneId: "",
    lastdocumentupdatedon: sessionStorage.getItem("lastdocumentupdatedon"),
  };

  const resolveNotesHandler = (noteDetails) => {
    setNotesId(noteDetails.id);
    let reqPayload = {
      documentnotesid: noteDetails.id,
      documentversionid: _.isEmpty(docDetailsList?.tmfdropzoneid)
        ? docDetailsList.documentversionguid
        : APP_CONST.HARD_CODED.dummyId,
      tmfdropzoneid: !_.isEmpty(docDetailsList?.tmfdropzoneid)
        ? docDetailsList?.tmfdropzoneid
        : APP_CONST.HARD_CODED.dummyId,
    };
    dispatch(
      documentActions.resolveDocNote(
        reqPayload,
        docDetailsList?.origiartifactid
      )
    );
    dispatch({ type: "AGGRID_GET_CALL", payload: payload });
  };

  const renderNotesSection = () => {
    return (
      <div className="status-row">
        <div className="comment-box">
          {notesListArray?.slice(0).map((note, index) => {
            return (
              <Fragment key={index}>
                <div className="d-flex align-center jc-space-btw note-container">
                  <div className="note-details">
                    <viedoc-icon name="note" />
                    <div>
                      <p title={note.note} className="sem-pri-color">
                        {note.note.length <= 80
                          ? note.note
                          : note.note.substring(0, 80) + "..."}
                      </p>
                      <p className="gray-60">
                        {` ${t("TMF.TEXT_ADDED")} `}
                        {fullDateTimePattern && note.createdon
                          ? UtilsHelper.getFormattedDateTime(
                              fullDateTimePattern,
                              note.createdon,
                              dateLocale
                            )
                          : UtilsHelper.momentLocalConversion(
                              note.createdon,
                              true
                            )}
                        {note.createdby && (
                          <>
                            {` ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
                              userList,
                              note.createdby
                            )}`}
                          </>
                        )}
                      </p>
                    </div>
                  </div>
                  {noteResolving && notesId === note.id ? (
                    <viedoc-spinner />
                  ) : (
                    <>
                      {!isEtmfLocked &&
                        (docDetailsList?.writePermission ||
                          docDetailsList?.reviewPermission ||
                          isDropZoneDoc) && (
                          <a
                            href
                            title={t("TMF.TEXT_RESOLVE")}
                            className="anchor"
                            onClick={() => resolveNotesHandler(note)}
                          >
                            {t("TMF.TEXT_RESOLVE")}
                          </a>
                        )}
                    </>
                  )}
                </div>
              </Fragment>
            );
          })}
        </div>
      </div>
    );
  };

  const getSharingStatusVisible = () => {
    let showSharingStatus = false;
    if (docDetailsList?.status !== APP_CONST.TEXT_UNPUBLISHED) {
      if (
        docDetailsList?.status === APP_CONST.TEXT_FINALIZED &&
        docShareCount.availableBindersWithRecalledCount === 0 &&
        !isEtmfLocked &&
        ((isDocShareViedocUser &&
          docDetailsList?.trialmasterfilesharingsettings
            .isenabledforclinicalusers) ||
          (isDocShareViedocMeUser &&
            docDetailsList?.trialmasterfilesharingsettings
              .isenabledforsubjectusers)) &&
        latestDocVersion
      ) {
        showSharingStatus = true;
      } else if (
        docDetailsList.status === APP_CONST.TEXT_FINALIZED &&
        docShareCount.availableBindersWithRecalledCount >= 1 &&
        (isDocShareViedocUser ||
          isDocShareViedocMeUser ||
          isReadOnlySharingPanel) &&
        latestDocVersion &&
        !isEtmfLocked
      ) {
        showSharingStatus = true;
      } else if (
        docDetailsList.status === APP_CONST.TEXT_AWAITINGREVIEW &&
        docShareCount.availableBindersWithRecalledCount >= 1 &&
        (isDocShareViedocUser ||
          isDocShareViedocMeUser ||
          isReadOnlySharingPanel) &&
        latestDocVersion &&
        !isEtmfLocked
      ) {
        showSharingStatus = true;
      }
    } else {
      showSharingStatus = false;
    }
    return showSharingStatus;
  };

  const renderDocumentSharingPanel = () => {
    return (
      <>
        {getSharingStatusVisible() && (
          <div className="approval-details-list mt-12">
            <p>{t("TMF.TEXT_FILESHARING")}</p>
            <div className="sharingContainer">
              <div className="shareCountStyle">
                <viedoc-icon name="sharing" />
                <span className="pl-5 pr-5">
                  {docShareCount.availableBindersCount}
                </span>
              </div>
              {docShareCount.availableBindersCount !== 0 && (
                <div className="shareCountStyle">
                  <viedoc-icon name="load" />
                  <span className=" pr-10">
                    {docShareCount.inCompleteBindersCount}
                  </span>
                  <viedoc-icon name="check" />
                  <span className="pl-5 pr-5">
                    {docShareCount.completedBindersCount}
                  </span>
                </div>
              )}
              <div className="awiting-option" title={!metricsLoader ? t("TMF.TEXT_SHARING_ACTIONS") : ""}>
                {metricsLoader ? (
                  <viedoc-spinner
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                ) : (
                  <span onClick={(e) => setShowDocsharing(true)}>...</span>
                )}
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const renderDocumentClassification = () => {
    return (
      <div className="document-classification pt-20">
        <div className="classification-header">
          <p className="">{t("ADMIN.TEXT_CLASSIFICATIONLBL")}</p>
          <div className="sub-header">
            <label>{t("TMF.TEXT_TMFLOCATIONLBL")}</label>
            <div className="classification-folder">
              <div className="classification-trail">
                <viedoc-icon name="folder" />
                <span>
                  {docStatusChangeInProgress &&
                  !_.isEmpty(documentPayload?.documentDetails?.zone)
                    ? documentPayload?.documentDetails?.zone
                    : docDetailsList?.zone}
                </span>
              </div>
              <div className="classification-bar"></div>
              <div className="classification-committee">
                <viedoc-icon name="folder" />
                <span>
                  {docStatusChangeInProgress &&
                  !_.isEmpty(documentPayload?.documentDetails?.section)
                    ? documentPayload?.documentDetails?.section
                    : docDetailsList?.section}
                </span>
              </div>
              <div className="classification-bar"></div>
              <div className="classification-process">
                <viedoc-icon name="folder" />
                <span>
                  {docStatusChangeInProgress &&
                  !_.isEmpty(documentPayload?.documentDetails?.artifact)
                    ? documentPayload?.documentDetails?.artifact
                    : docDetailsList?.artifact}
                </span>
              </div>
            </div>
          </div>
          <div className="sub-header sub-center">
            <label>{t("TMF.TEXT_SCOPE")}</label>
            <div className="sub-select">
              {docStatusChangeInProgress &&
              !_.isEmpty(documentPayload?.documentDetails?.documenttmflevel)
                ? UtilsHelper.getTranslatedScopeLabel(documentPayload?.documentDetails?.documenttmflevel)
                : UtilsHelper.getTranslatedScopeLabel(docDetailsList?.documenttmflevel) || "---"}
            </div>
          </div>
          <div className="sub-header sub-center">
            <label>{t("TMF.TEXT_DOCTYPELBL")} </label>
            <div className="sub-select">
              {`${
                docStatusChangeInProgress &&
                !_.isEmpty(documentPayload?.documentDetails?.documenttype)
                  ? documentPayload?.documentDetails?.documenttype === "Other"
                    ? "Custom type:"
                    : `${documentPayload?.documentDetails?.documenttype}:`
                  : docDetailsList?.documenttype === "Other"
                  ? "Custom type:"
                  : `${
                      !_.isEmpty(docDetailsList?.documenttype)
                        ? `${docDetailsList?.documenttype}:`
                        : "---"
                    }`
              } ${
                docStatusChangeInProgress &&
                !_.isEmpty(documentPayload?.documentDetails?.documenttypevalue)
                  ? documentPayload?.documentDetails?.documenttypevalue
                  : docDetailsList?.documenttypevalue || ""
              }`}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getSharingDetails = (documentDetails) => {
    const { trialmasterfilesharingsettings } = documentDetails;

    return trialmasterfilesharingsettings?.isenabledforclinicalusers
      ? t("TMF.TEXT_VIEDOCCLINICALUSERS")
      : trialmasterfilesharingsettings?.isenabledforsubjectusers
      ? t("TMF.LABEL_VIEDOCMEUSERS")
      : "---";
  };

  const renderDocumentInfo = () => {
    return (
      <>
        <div className="document-info">
          <div className="document-info-header">
            <p>{t("TMF.TEXT_DOCINFOLBL")}</p>
          </div>
          {documentInfoList.map((docInfo) => {
            return (
              <div className="sub-header" key={docInfo.label}>
                <p>{docInfo.label}</p>
                <div className="document-checkbox">{docInfo.displayValue}</div>
              </div>
            );
          })}
        </div>
        <div className="bb-1 mt-20"></div>
        <div className="document-info pt-20">
          <div className="document-info-header">
            <p>{t("TMF.TEXT_FILEINFOLBL")}</p>
          </div>
          {fileInfoList.map((fileInfo) => {
            return (
              <div className="sub-header" key={fileInfo.label}>
                <p>{fileInfo.label}</p>
                <div className="document-checkbox">{fileInfo.displayValue}</div>
              </div>
            );
          })}
          <div className="bb-1 mt-20"></div>
        </div>
        <div className="document-info pt-20">
          <div className="document-info-header">
            <p>{t("ADMIN.ADMINTAB_SHARING")}</p>
          </div>
          <div className="sub-header">
            <p>{t("TMF.TEXT_ENABLEFOR")}</p>
            <div className="document-checkbox">
              {docStatusChangeInProgress
                ? getSharingDetails(completePayload)
                : getSharingDetails(docDetailsList)}
            </div>
          </div>
        </div>
      </>
    );
  };

  const downloadFile = (historyChanges) => {
    const fileProps = {
      documentguid: historyChanges.historyentitychanges.filter(
        (history) => history.fieldname === "File guid"
      )[0].oldvalue,
      type: historyChanges.historyentitychanges.filter(
        (history) => history.fieldname === "File type"
      )[0].oldvalue,

      origfilename: historyChanges.historyentitychanges.filter(
        (history) => history.fieldname === "File"
      )[0].oldvalue,
      documentid: historyChanges.documentid,
      lastmodifiedon: docDetailsList?.lastmodifiedon,
      documentversionguid: docDetailsList?.documentversionguid,
      from: "history",
    };

    const downloadFileName = fileProps.origfilename?.split(
      `.${fileProps.type}`
    )[0];

    dispatch(
      fileUploadActions.fileDownloadUrl(
        UtilsHelper.prepareDownloadRequestPayload({
          ...fileProps,
          downloadFileName,
        }),
        true
      )
    );
  };

  const renderHistoryWithLog = (data, historyText) => {
    return (
      <p className="history-view">
        {`${historyText} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                data.createdon,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(data.createdon)
        }  ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
          userList,
          data.userid
        )}`}
        {!_.isEmpty(data.historyentitychanges) &&
          data.historyentitychanges.map((item, index) => {
            if (datingConvention.includes(item.fieldname)) {
              return (
                <span key={index}>
                  <span>
                    {`${getFieldValue(item.fieldname)}`}:{" "}
                    {item.oldvalue
                      ? moment(item?.oldvalue).format("DD MMM YYYY")
                      : "-"}
                    <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                    {`${moment(item?.newvalue).format("DD MMM YYYY")}  `}
                  </span>
                </span>
              );
            }
            if (item.fieldname === "File date") {
              return (
                <span key={index}>
                  <span>
                    {`${t("TMF.TEXT_FILEDATE")}`}:{" "}
                    {item.oldvalue
                      ? UtilsHelper.getFormattedDateTime(
                          fullDateTimePattern,
                          item.oldvalue,
                          dateLocale
                        )
                      : "-"}
                    <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                    {`${UtilsHelper.getFormattedDateTime(
                      fullDateTimePattern,
                      item.newvalue,
                      dateLocale
                    )}  `}
                  </span>
                </span>
              );
            }
            if (
              item.fieldname !== "Original file name" &&
              item.fieldname !== "File guid" &&
              item.fieldname !== "File size" &&
              item.fieldname !== "File type" &&
              item.fieldname !== "LabelDateChange"
            ) {
              return (
                <span key={index}>
                  {`${getFieldValue(item.fieldname)}`}:{" "}
                  {!_.isEmpty(downloadingFiles) &&
                  docDetailsList?.documentname === item.newvalue ? (
                    <viedoc-spinner class="download__spinner"></viedoc-spinner>
                  ) : item.fieldname !== "File" ? (
                    <span>{item?.oldvalue}</span>
                  ) : (
                    <a
                      href
                      style={{
                        color: item.fieldname === "File" ? "#1e8ae4" : "",
                        cursor: "pointer",
                      }}
                      onClick={() => downloadFile(data)}
                    >
                      {` ${item.oldvalue ? item.oldvalue : "-"} `}
                    </a>
                  )}
                  <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                  {`${item?.newvalue}  `}
                </span>
              );
            }
          })}
      </p>
    );
  };

  const renderbinderHistory = (
    history,
    historyTextStatus,
    downloadNoteHistory
  ) => {
    return (
      <p className="history-view">
        {`${t("COMMON.TEXT_DOCUMENT")} ( ${t("TMF.LABEL_BINDERID")}: ${
          history.binderid
        } ) ${
          !downloadNoteHistory ? t("TMF.TEXT_DOCUMENTSNOTES") : ""
        } ${historyTextStatus} ${t("TMF.TEXT_ON")} ${
          fullDateTimePattern
            ? UtilsHelper.getFormattedDateTime(
                fullDateTimePattern,
                history.createdon,
                dateLocale
              )
            : UtilsHelper.momentLocalConversion(history.createdon, true)
        } ${t("TMF.TEXT_BY")} ${history.username ? history?.username :  history?.userid} `}
      </p>
    );
  };

  const FileHistoryText = (data) => {
    switch (data.status) {
      case "Downloaded":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_DOWNLOADED")} ${data?.filename} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            }	
            ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}  ${t("TMF.TEXT_THATWASUPLOAD")}  	
          ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  data?.uploadedon,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(data?.uploadedon, true)
          }`}
          </p>
        );
      case "Finalized":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_FINALIZED")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
          </p>
        );
      case "Document Version Created":
        let docHistory = data.comment.match(/\(([^)]+)\)/);
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_ANEWVERSION")} ${docHistory[1]} ${t(
              "TMF.TEXT_CREATED"
            )} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
          </p>
        );

      case "A new file uploaded":
        return (
          <p className="history-view">
            {`${data.comment} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
          </p>
        );

      case "shared":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_ARECORD")} ( ${t("TMF.LABEL_BINDERID")}: ${
              data.binderid
            } ) ${t("TMF.TEXT_WASSHARED")} ${t("TMF.TEXT_WITH")} ${
              data.recipientcount
            } ${
              data.recipientcount === 1
                ? t("TMF.TEXT_RECIPIENT")
                : t("TMF.TEXT_LOWEERCASERECIPIENTS")
            } ${
              data.cosignatorycount > 0
                ? `${t("TMF.TEXT_AND")} ${data.cosignatorycount} ${
                    data.cosignatorycount > 1
                      ? t("TMF.TEXT_PLURALCOSIGN")
                      : t("TMF.TEXT_SINGULARCOSIGN")
                  }`
                : ""
            } ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
          </p>
        );

      case "SharingRecalled":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_SHARINGREVOKED")} ( ${t("TMF.LABEL_BINDERID")}: ${
              data.binderid
            } ) ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
          </p>
        );

      case "viewed":
        return (
          <p className="history-view">
            {`${t("COMMON.TEXT_DOCUMENT")} ( ${t("TMF.LABEL_BINDERID")}: ${
              data.binderid
            } ) ${t("TMF.TEXT_VIEWED")} ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            }  ${t("TMF.TEXT_BY")} ${
              data.username !== "" ? data.username : data.userid
            }`}
          </p>
        );

      case "signed":
        return (
          <p className="history-view">
            {`${data.username !== "" ? data.username : data.userid} ${t(
              "TMF.TEXT_SIGNED"
            )} ( ${t("TMF.LABEL_BINDERID")}: ${data.binderid} ) ${t(
              "TMF.TEXT_WITHONETIMECODE"
            )} ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_WITHREASON")} "${t(
              `TMF.${UtilsHelper.getSignReasonTranslateKey(data.reason)}`
            )}"`}
          </p>
        );

      case "downloadsharingdetails":
        return (
          <p className="history-view">{`${t("COMMON.TEXT_DOCUMENT")} ( ${t(
            "TMF.LABEL_BINDERID"
          )}: ${data.binderid} ) ${t("TMF.TEXT_DOWNLOADEDWITHSHARING")} ${t(
            "TMF.TEXT_ON"
          )} ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  data.createdon,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(data.createdon, true)
          } ${t("TMF.TEXT_BY")} ${data.username}`}</p>
        );

      case "downloaded":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_ORIGINALFILEDOWNLOADED")} ( ${t(
              "TMF.LABEL_BINDERID"
            )}: ${data.binderid} ) | ${data.filename} ${t("TMF.TEXT_ON")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${data.username}`}
          </p>
        );

      case "downloadwithsignature":
        return (
          <p className="history-view">{`${t("COMMON.TEXT_DOCUMENT")} ${t(
            "TMF.TEXT_DOWNLOADEDSIGNATURE"
          )} ( ${t("TMF.LABEL_BINDERID")}: ${data.binderid} ) ${t(
            "TMF.TEXT_ON"
          )} ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  data.createdon,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(data.createdon, true)
          } ${t("TMF.TEXT_BY")} ${data.username}`}</p>
        );

      case "Flagged by QC":
        return (
          <p className="history-view">
            <p>{`${t("TMF.TEXT_FLAGGEDBYQC")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")}  ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}</p>
            <p className="d-flex light-grey">
              Comment: <span className="pl-3">{data?.comment}</span>{" "}
            </p>
          </p>
        );
      case "Modified":
        return (
          <p className="history-view">
            <p>
              {`${t("TMF.TEXT_MODIFIED")}  ${
                fullDateTimePattern
                  ? UtilsHelper.getFormattedDateTime(
                      fullDateTimePattern,
                      data.createdon,
                      dateLocale
                    )
                  : UtilsHelper.momentLocalConversion(data.createdon, true)
              } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
                userList,
                data.userid
              )}`}
            </p>
            {data.historyentitychanges.map((item, index) => {
              if (datingConvention.includes(item.fieldname)) {
                return (
                  <span key={index}>
                    <span>
                      {`${getFieldValue(item.fieldname)}`}:{" "}
                      {item.oldvalue
                        ? moment(item?.oldvalue).format("DD MMM YYYY")
                        : "-"}
                      <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                      {`${moment(item?.newvalue).format("DD MMM YYYY")}  `}
                    </span>
                  </span>
                );
              }
              if (item.fieldname === "File date") {
                return (
                  <span key={index}>
                    <span>
                      {`${t("TMF.TEXT_FILEDATE")}`}:{" "}
                      {item.oldvalue
                        ? UtilsHelper.getFormattedDateTime(
                            fullDateTimePattern,
                            item.oldvalue,
                            dateLocale
                          )
                        : "-"}
                      <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                      {`${UtilsHelper.getFormattedDateTime(
                        fullDateTimePattern,
                        item.newvalue,
                        dateLocale
                      )}  `}
                    </span>
                  </span>
                );
              }
              if (
                item.fieldname === "LabelDateChange" &&
                item.oldvalue !== ""
              ) {
                <p className="modified-view">
                  <span>{` ${item?.oldvalue}  `}</span>
                </p>;
              }
              if (
                item.fieldname !== "Original file name" &&
                item.fieldname !== "File size" &&
                item.fieldname !== "File guid" &&
                item.fieldname !== "File type" &&
                item.fieldname !== "LabelDateChange"
              ) {
                return (
                  <p key={index} className="modified-view">
                    <span>{`${getFieldValue(item.fieldname)}`}:</span>{" "}
                    <span className="f14 ml-5">
                      {!_.isEmpty(downloadingFiles) &&
                      docDetailsList?.documentname === item.newvalue ? (
                        <viedoc-spinner class="download__spinner"></viedoc-spinner>
                      ) : item.fieldname !== "File" ? (
                        <span>{item.oldvalue ? item?.oldvalue : "-"}</span>
                      ) : (
                        <a
                          href
                          style={{
                            color: item.fieldname === "File" ? "#1e8ae4" : "",
                            cursor: "pointer",
                          }}
                          onClick={() => downloadFile(data)}
                        >
                          {item.oldvalue ? item?.oldvalue : "-"}
                        </a>
                      )}
                    </span>
                    <viedoc-icon name="play_arrow"></viedoc-icon>
                    <span>{` ${item?.newvalue}  `}</span>
                  </p>
                );
              }
            })}
          </p>
        );
      case "Document unlocked":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_DOCUMENTUNLOCKED")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")}  ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
            {data.historyentitychanges.map((item) => {
              return (
                <span>
                  {`${getFieldValue(item.fieldname)}`}: {` ${item?.oldvalue}`}
                  <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                  {`${item?.newvalue}  `}
                </span>
              );
            })}
          </p>
        );
      case "Document locked":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_DOCUMENTLOCKED")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
            {data.historyentitychanges.map((item) => {
              return (
                <span>
                  {`${getFieldValue(item.fieldname)}`}: {` ${item?.oldvalue}`}
                  <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                  {`${item?.newvalue}  `}
                </span>
              );
            })}
          </p>
        );
      case "Awaiting review":
      case "Saved as Unpublished":
        return (
          <p className="history-view">
            {getStatus(data.status)}{" "}
            {`${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            }	
            ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
            {data.historyentitychanges.map((item, index) => {
              if (datingConvention.includes(item.fieldname)) {
                return (
                  <span key={index}>
                    <span>
                      {`${getFieldValue(item.fieldname)}`}:{" "}
                      {item.oldvalue
                        ? moment(item?.oldvalue).format("DD MMM YYYY")
                        : "-"}
                      <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                      {`${moment(item?.newvalue).format("DD MMM YYYY")}  `}
                    </span>
                  </span>
                );
              }
              if (item.fieldname === "File date") {
                return (
                  <span key={index}>
                    <span>
                      {`${t("TMF.TEXT_FILEDATE")}`}:{" "}
                      {item.oldvalue
                        ? UtilsHelper.getFormattedDateTime(
                            fullDateTimePattern,
                            item.oldvalue,
                            dateLocale
                          )
                        : "-"}
                      <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                      {`${UtilsHelper.getFormattedDateTime(
                        fullDateTimePattern,
                        item.newvalue,
                        dateLocale
                      )}  `}
                    </span>
                  </span>
                );
              }
              if (
                item.fieldname !== "Original file name" &&
                item.fieldname !== "File guid" &&
                item.fieldname !== "File size" &&
                item.fieldname !== "File type" &&
                item.fieldname !== "LabelDateChange"
              ) {
                return (
                  <span key={index}>
                    {`${getFieldValue(item.fieldname)}`}:{" "}
                    {!_.isEmpty(downloadingFiles) &&
                    docDetailsList?.documentname === item.newvalue ? (
                      <viedoc-spinner class="download__spinner"></viedoc-spinner>
                    ) : item.fieldname !== "File" ? (
                      <span>{item?.oldvalue}</span>
                    ) : (
                      <a
                        href
                        style={{
                          color: item.fieldname === "File" ? "#1e8ae4" : "",
                          cursor: "pointer",
                        }}
                        onClick={() => downloadFile(data)}
                      >
                        {` ${item.oldvalue ? item.oldvalue : "-"} `}
                      </a>
                    )}
                    <viedoc-icon name="play_arrow"></viedoc-icon>{" "}
                    {`${item?.newvalue}  `}
                  </span>
                );
              }
            })}
          </p>
        );
      case "Uploaded as Unpublished":
      case "Uploaded to drop zone":
        return (
          <p className="history-view">
            {`${getStatus(data.status)}  ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
          </p>
        );
      case "Uploaded":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_UPLOADED")} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon, true)
            } ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
              userList,
              data.userid
            )}`}
          </p>
        );
      case "Previewed":
        return (
          <p className="history-view">
            {`${t("TMF.TEXT_PREVIEWED")} ${data.filename} ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data.createdon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data.createdon)
            } ${t("TMF.TEXT_BY")}	
            ${UtilsHelper.findUserName(userList, data.userid)}	
            ${t("TMF.TEXT_THATWASUPLOAD")}  	
            ${
              fullDateTimePattern
                ? UtilsHelper.getFormattedDateTime(
                    fullDateTimePattern,
                    data?.uploadedon,
                    dateLocale
                  )
                : UtilsHelper.momentLocalConversion(data?.uploadedon, true)
            } `}
          </p>
        );

      case "Unpublished":
        return renderHistoryWithLog(data, t("TMF.TEXT_FORMCONTROLADDED"));

      case "CloneFormFile":
        return renderHistoryWithLog(
          data,
          t("TMF.TEXT_NEWDOCVERSIONFORMCONTROLADDED")
        );

      case "notesadded":
        return renderbinderHistory(data, t("TMF.TEXT_DOCUMENTADDED"));
      case "notesupdated":
        return renderbinderHistory(data, t("TMF.TEXT_DOCUMENTUPDATED"));
      case "notesdeleted":
        return renderbinderHistory(data, t("TMF.TEXT_DOCUMENTDELETED"));
      case "downloadwithnotes":
        return renderbinderHistory(data, t("TMF.TEXT_DOWNLOADEDNOTES"), true);

      default:
        <p className="history-view">
          {`${
            data.status === "Awaiting review"
              ? t("TMF.TEXT_AWAITING")
              : data.status === "Document unlocked"
              ? t("TMF.TEXT_DOCUMENTUNLOCKED")
              : data.status === "Uploaded as Unpublished"
              ? t("TMF.TEXT_UPLOADUNPUBLISHED")
              : data.status === "Uploaded to drop zone"
              ? t("TMF.TEXT_UPLOADEDDROPZONE")
              : data.status === "Document locked"
              ? t("TMF.TEXT_DOCUMENTLOCKED")
              : ""
          } ${
            fullDateTimePattern
              ? UtilsHelper.getFormattedDateTime(
                  fullDateTimePattern,
                  data.createdon,
                  dateLocale
                )
              : UtilsHelper.momentLocalConversion(data.createdon, true)
          }	
            ${t("TMF.TEXT_BY")} ${UtilsHelper.findUserName(
            userList,
            data.userid
          )}`}
        </p>;
    }
  };

  const getFieldValue = (fieldValue) => {
    switch (fieldValue) {
      case "Dating convention":
        return t("TMF.TEXT_DATINGCONVENTION");
      case "Tmf level":
        return t("TMF.TEXT_TMFLEVELLBL");
      case "Document type":
        return t("TMF.TEXT_DOCTYPELBL");
      case "Zone name":
        return t("TMF.TEXT_ZONENAME");
      case "Section name":
        return t("TMF.TEXT_SECTIONNAME");
      case "Artifact name":
        return t("TMF.TEXT_ARTIFACTNAME");
      case "Document sharing enabled for":
        return t("ADMIN.ADMINTAB_SHARINGENABLEDFOR");
      case "Document name":
        return t("ARCHIVE.TEXT_DOCUMENTNAME");

      default:
        return fieldValue;
    }
  };

  const renderDocumentHistory = () => {
    return (
      <div className="document-history">
        <div className="document-history-header">
          <p>{t("TMF.TEXT_HISTORY")}</p>
        </div>

        {historyLoading ? (
          <div className="d-flex jc-center align-center">
            <viedoc-spinner></viedoc-spinner>
          </div>
        ) : (
          <div className="document-history-info">
            {!_.isEmpty(documentHistoryList) &&
              documentHistoryList.map((fieldvalue, index) => (
                <Fragment key={index}>{FileHistoryText(fieldvalue)}</Fragment>
              ))}
          </div>
        )}
      </div>
    );
  };

  const displayFullScreen = () => {
    return `popup-flex-container  ${
      isDocVisible && previewFileURL !== "" && previewFileURL !== undefined
        ? "is-document-open"
        : "is-single-popup"
    }`;
  };

  const renderReadOnlyMode = () => {
    return (
      <>
        {renderDocumentClassification()}
        <div className="bb-1 mt-20"></div>

        {renderDocumentInfo()}

        <div className="bb-1 mt-20"></div>
      </>
    );
  };

  const hideToaster = () => {
    setShowToaster(false);
    dispatch(documentActions.clearDocErrorMessage());
    dispatch(fileUploadActions.clearFileErrorMessage());
    dispatch(fileUploadActions.singleFileErrorToaster(""));
  };

  const renderToaster = (message) => {
    return (
      ((showRequiredWarnings && showToaster) ||
        !_.isEmpty(docPropErrorMessage) ||
        !_.isEmpty(fileErrorMessage) ||
        !_.isEmpty(singleFileErrorMessage)) && (
        <viedoc-toaster
          onClick={() => hideToaster()}
          variant="error"
          prefix-icon="warning"
          toasterMsg={message}
        ></viedoc-toaster>
      )
    );
  };
  
  function isDocumentReadOnly() {
    if (!isDropZoneDoc && _.isEmpty(docDetailsList?.status)) {
      return true;
    }
    if (!docDetailsList?.tmfdropzoneid) {
      return (
        !docDetailsList.writePermission ||
        isEtmfLocked ||
        ((docDetailsList.status === "Flagged by QC" ||
          docDetailsList.status === "Awaiting review") &&
          !isEditModeClicked) ||
        docDetailsList.status === "Finalized"
      );
    }
    return false;
  }
  let isDocReadOnly = isDocumentReadOnly();

  return (
    <ViedocDialogElement
      id="doc-view-popup"
      size="large"
      open
      optionalClose={isEditFormTouched ? true : null}
      preventCloseByClick
      onHide={(e) => onHide(e)}
      onClick={(e) => dialogCloseHandler(e)}
      class={`document-view 
      ${
        isDocVisible && previewFileURL !== "" && previewFileURL !== undefined
          ? "a"
          : "b"
      }`}
    >
      {renderHeaderDocumentView()}

      <div id="resizeHandle" className={displayFullScreen()}>
        {versionLoader || cloneLoading || isRelocatingDoc ? (
          <Loader width={"100%"} height={"100%"} borderRadius />
        ) : (
          <PanelGroup direction="horizontal" ref={ref}>
            {isDocVisible &&
              previewFileURL !== "" &&
              previewFileURL !== undefined && (
                <Panel
                  ref={ResizeHandle}
                  defaultSize={50}
                  minSize={22}
                  order={1}
                  collapsible={false}
                >
                  <div className="d-flex justfy-content-flex-end">
                    <div
                      className="fullScreenIcon"
                      title={fullDocument ? "Exit Full Screen" : "Full Screen"}
                      onClick={() => {
                        const panelGroup = ref.current;
                        if (panelGroup) {
                          // Reset each Panel to 50% of the group's width
                          if (!fullDocument) {
                            panelGroup.setLayout([100, 0]);
                          } else {
                            panelGroup.setLayout([50, 50]);
                          }
                          setfullDocument(!fullDocument);
                        }
                      }}
                    >
                      {isNotDragging && !isErrorFile && (
                        <div className={isPortfolioTabOpen ? "not-draggingtop" : "not-dragging"}>
                          <viedoc-icon
                            name={
                              !fullDocument
                                ? "close_in_full"
                                : "close_fullscreen"
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div id="webviewContainer">
                    <WebView
                      previewURL={previewFileURL}
                      fileName={fileName}
                      fileType={isNewVersionCreated && tmpGuid ? UtilsHelper.getFileExtension(singleFileDetail[0].name) :  fileType}
                      scrollEnabled={true}
                      scalesPageToFit={true}
                      fullDocument={fullDocument}
                      onClick={() => {
                        setfullDocument(!fullDocument);
                      }}
                      docStatus={docDetailsList?.status}
                      isNewVersionCreated={isNewVersionCreated}
                      writePermission={docDetailsList.writePermission}
                      isErrorFile={isErrorFile}
                      setIsErrorFile={setIsErrorFile}
                      unSavedFormFields={unSavedFormFields}
                      setIsPortfolioTabOpen={setIsPortfolioTabOpen}
                    ></WebView>
                  </div>
                </Panel>
              )}
            {isDocVisible &&
              previewFileURL !== "" &&
              previewFileURL !== undefined && (
                <PanelResizeHandle
                  className="resizeHandler"
                  onDragging={(size, e) => {
                    // code to drag panel left and right

                    const element = document.querySelector("#webviewContainer");
                    element.style.pointerEvents = "none";
                    const panelGroup = ref.current;
                    if (!panelGroup) return;
                    //const layout = panelGroup.getLayout();
                    if (size >= 100) {
                      setfullDocument(true);
                    } else if (size <= 22) {
                      setfullDocument(false);
                    }
                    setTimeout(() => {
                      element.style.pointerEvents = "auto";
                    }, 2000);
                  }}
                />
              )}
            <Panel defaultSize={50} minSize={0} collapsible={true} order={2}>
              {renderToaster(
                !_.isEmpty(docPropErrorMessage) ||
                  !_.isEmpty(fileErrorMessage) ||
                  !_.isEmpty(singleFileErrorMessage)
                  ? docPropErrorMessage ||
                      fileErrorMessage ||
                      singleFileErrorMessage
                  : t("TMF.TOAST_REQUIRED")
              )}
              <div className="documentViewModal">
                {showDocDeletePopup && (
                  <DeleteDocumentPopUp
                    deletePayload={docDeleteData}
                    setShowDocDeletePopup={setShowDocDeletePopup}
                    sectionOrigid={sectionOrigid}
                    origiartifactid={docDetailsList?.origiartifactid}
                    category={isDropZoneDoc ? docDetailsList?.category : ""}
                    fromTo={isDropZoneDoc ? "Dropzone" : ""}
                  />
                )}

                {docActionObj && (
                  <DocumentActionModal
                    setDocActionObj={setDocActionObj}
                    docDetailsList={docDetailsList}
                    setdocDetailsList={setdocDetailsList}
                    setActionText={setActionText}
                    actionText={actionText}
                    setActionId={setActionId}
                    setCommentListArray={setCommentListArray}
                    setIsActionLoading={setIsActionLoading}
                    setIsAwaitingFlagged={setIsAwaitingFlagged}
                    setAddedComments={setAddedComments}
                    setIsEditMode={setIsEditMode}
                    setIsNewVersionCreated={setIsNewVersionCreated}
                    setNewVersionType={setNewVersionType}
                    isNewVersionCreated={isNewVersionCreated}
                    latestDocVersion={latestDocVersion}
                    setIsDocVisible={setIsDocVisible}
                    selectedArtifactDetails={selectedArtifactDetails}
                  />
                )}
                {showCloseConfirmation && (
                  <CloseConfirmationPopUp
                    setShowCloseConfirmation={setShowCloseConfirmation}
                  />
                )}

                {showDocsharing && (
                  <FileSharingDialog
                    setShowDocsharing={setShowDocsharing}
                    docDetailsList={docDetailsList}
                    isNoBindersAvailable={
                      docShareCount.availableBindersWithRecalledCount === 0
                    }
                  />
                )}
                {showFormField.isOpen && renderFormFieldError()}
                {renderFileHeader()}
                <div className="pb-20 approval-stage">
                  {renderTextFieldValues()}
                  {renderCommentSection()}
                  {renderNotesSection()}
                  {renderDocumentSharingPanel()}
                  {documentVersionList?.length > 1 &&
                    latestVersion !== docShareCount.minDocumentVersionNumber &&
                    docShareCount.minDocumentVersionNumber > 0 &&
                    getSharingStatusVisible() && (
                      <div className="approval-details-list mt-12">
                        <p className="fw-700">{t("TMF.TEXT_NOTE")}</p>
                        <p>{t("TMF.TEXT_SHARINGINCLUDESOLDDOCUMENTVERSION")}</p>
                      </div>
                    )}
                </div>

                <div className="bb-1 mt-20"></div>
                {isDocReadOnly && renderReadOnlyMode()}
                <div style={{ display: isDocReadOnly ? "none" : "" }}>
                  <DocumentEditForm
                    docDetailsList={docDetailsList}
                    docStatusPayload={docStatusPayload}
                    showRequiredWarnings={showRequiredWarnings}
                    setShowRequiredWarnings={setShowRequiredWarnings}
                    setIsEditFormTouched={setIsEditFormTouched}
                    setShowToaster={setShowToaster}
                    showToaster={showToaster}
                    setSingleFileUploaded={setSingleFileUploaded}
                    singleFileUploaded={singleFileUploaded}
                    setNewArtifactId={setNewArtifactId}
                    selectedArtifactDetails={selectedArtifactDetails}
                    newVersionType={newVersionType}
                    isNewVersionCreated={isNewVersionCreated}
                    tmpGuid={tmpGuid}
                    setTmpGuid={setTmpGuid}
                    isDropZoneDoc={isDropZoneDoc}
                    setDocPermission={setDocPermission}
                    setArtifactUserAccess={setArtifactUserAccess}
                    resetFormToInitial={resetFormToInitial}
                    setResetFormToInitial={setResetFormToInitial}
                    isEditMode={isEditMode}
                    isFileUpload={isFileUpload}
                    setIsFileUpload={setIsFileUpload}
                    isDocReadOnly={isDocReadOnly}
                    setSingleFileDetail = {setSingleFileDetail}
                    setTmpFileGuid={setTmpFileGuid}
                    setTmpSingleFileDetail={setTmpSingleFileDetail}
                    setIsDocNewVersionCreated={setIsDocNewVersionCreated}
                  />
                </div>
                {!isNewVersionCreated &&
                  !isDropZoneDoc &&
                  renderDocumentHistory()}
              </div>
            </Panel>
          </PanelGroup>
        )}
      </div>

      <footer slot="footer"></footer>
    </ViedocDialogElement>
  );
};

export default DocumentViewModal;
